var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { forwardRef, createRef, useEffect } from 'react';
// import isMobile from 'ismobilejs'
import cn from 'classnames';
import styles from 'core-components/src/components/dropdown/dropdown.scss';
export const Dropdown = forwardRef((_a, ref) => {
    var { raised, invalid, small, big, fluid, placeholder, options, 
    // onChoose,
    hideNativeSelect, icon, className } = _a, nativeProps = __rest(_a, ["raised", "invalid", "small", "big", "fluid", "placeholder", "options", "hideNativeSelect", "icon", "className"]);
    const _ref = createRef();
    const _selectRef = createRef();
    const coreStyles = cn({
        [styles.dropdown]: true,
        [styles.big]: big,
        [styles.fluid]: fluid,
        [styles.invalid]: invalid,
        [styles.raised]: raised,
        [styles.small]: small,
        [className]: className
    });
    const chooseOption = (value) => {
        const event = new Event('change', { bubbles: true });
        _selectRef.current.value = value;
        _selectRef.current.dispatchEvent(event);
    };
    useEffect(() => {
        if (ref && !ref.current) {
            if (typeof ref === 'object') {
                // eslint-disable-next-line no-param-reassign
                ref.current = _selectRef.current;
            }
            if (typeof ref === 'function') {
                ref(_selectRef.current);
            }
        }
    });
    useEffect(() => {
        // If isn't mobile, then prevent show the default dropdown
        // in order to show the custom one
        // if (!isMobile().any && hideNativeSelect) {
        // if (isMobile().any) {
        _selectRef.current.addEventListener('mousedown', (e) => {
            e.preventDefault();
            if (_selectRef.current) {
                if (document.activeElement === _selectRef.current) {
                    _selectRef.current.blur();
                }
                else {
                    _selectRef.current.focus();
                }
            }
        });
        // }
    });
    return (React.createElement("div", { className: coreStyles, ref: _ref },
        icon ? React.cloneElement(icon, { className: styles.icon }) : null,
        React.createElement("select", Object.assign({}, nativeProps, { ref: _selectRef }),
            React.createElement("option", { value: "", disabled: true }, placeholder),
            options.map((option) => (React.createElement("option", { key: option.value, value: option.value }, option.label)))),
        React.createElement("ul", { className: styles.customSelect },
            React.createElement("li", { "data-value": "", "data-disabled": true }, placeholder),
            options.map((option) => (React.createElement("li", { key: option.value, className: `${
                // eslint-disable-next-line eqeqeq
                option.value == nativeProps.value ? styles.selected : ''}`, onClick: () => chooseOption(option.value) }, option.label))))));
});
Dropdown.defaultProps = {
    raised: false,
    invalid: false,
    small: false,
    big: false,
    fluid: false,
    placeholder: '',
    options: [],
    value: '',
    // onChoose: () => {},
    hideNativeSelect: true,
    icon: null
};
